// store/index.js
import Vue from 'vue';
import Vuex from 'vuex';
const savedUserinfo = localStorage.getItem('userinfo');
let cartNum = localStorage.getItem('cartNumber');
Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		userinfo: savedUserinfo ? JSON.parse(savedUserinfo) : null, // 用户信息
		token: null, // 可选：token也可以放在这里管理
		cartNumber: cartNum ? cartNum : 0, // 购物车
	},
	mutations: {
		SET_USERINFO(state, userinfo) {
			state.userinfo = userinfo
		},
		CLEAR_USERINFO(state) {
			state.userinfo = null
		},
		CLEAR_CARTNUMBER(state) {
			state.cartNumber = 0
		},
		SET_CARTNUMBER(state, data) {
			state.cartNumber = data
		},
	},
	actions: {
		setUserInfo({
			commit
		}, userinfo) {
			commit('SET_USERINFO', userinfo)
		},
		clearUserInfo({
			commit
		}) {
			commit('CLEAR_USERINFO')
		},

		setCartNumber({
			commit
		}, data) {
			commit('SET_CARTNUMBER', data)
		},
		clearCartNumber({
			commit
		}) {
			commit('CLEAR_CARTNUMBER')
		},


	},
	getters: {
		getUserInfo: (state) => state.userinfo,
	},
});